module.exports = __webpack_public_path__ + "static/websites-banner-img-tiny-5e034850de4c0bdc4401ff703d3627e6.jpg";